import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import { listValue } from "../../utils/constant";
import { staticTexts } from "../../utils/Translate";

import "./versionList.m.css";

const VersionList = ({ publisherAttributes, domainSlug, className }) => {
  const value = domainSlug === "northamerica" ? "উত্তর আমেরিকা" : staticTexts(publisherAttributes.lang).language;

  const getSiteLink = (key) => {
    if (key === "bangla") {
      return publisherAttributes.bangla_sketches_host;
    } else if (key === "english") {
      return publisherAttributes.english_sketches_host;
    } else if (key === "north-america") {
      return "https://northamerica.prothomalo.com";
    }
  };

  return listValue.map((item, index) => (
    <li key={index} styleName="radio-item" className={className}>
      <Link aria-label={item.value} href={getSiteLink(item.key)}>
        <input type="radio" id={item.id} name={item.value} value={item.value} />
        <label
          className={`${value === item.value ? "label current-version" : "label"}`}
          styleName={`version-list ${value === item.value ? "current-version" : ""}`}
        >
          {item.value}
        </label>
      </Link>
    </li>
  ));
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], null),
});

export default connect(mapStateToProps, null)(VersionList);
